export default __webpack_public_path__ + "static/media/logo_lumen_horizontal.720d4f32.png";